module.exports = __webpack_public_path__ + "static/img/fr01.7c84c9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/fr01.png
// module id = ljZj
// module chunks = 18